import React from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap';


function SMSFormPayment() {

    const paymentHandler = (id) => {

    }

    return (
        <div>
            <div className="container">
                <div className="row justify-content-center pt-5 payment-list">
                    <div className="col-xs-11 cool-lg-9 rgc-request my-2 position-relative overflow-hidden" for="requestCode">
                        <div className='d-none d-md-block'>
                            <div className='d-flex flex-column gap-4 position-absolute'>
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                            </div>
                        </div>
                        <div  className="row rgc-content-request px-0 px-md-5 py-3 g-0">
                            <div className="col-xs-4 col-md-2">
                                تاریخ:
                            </div>
                            <div className="col-xs-8 col-md-2">
                                1402/01/02
                            </div>

                            <div className="col-xs-4 col-md-2">
                                شناسه قبض:
                            </div>
                            <div className="col-xs-8 col-md-2">
                                12345567890
                            </div>

                            <div className="col-xs-4 col-md-2">
                                شناسه پرداخت:
                            </div>
                            <div className="col-xs-8 col-md-2">
                                987654
                            </div>
                            <hr />

                            <div className="col-xs-12 col-md-6">
                                <div className='d-flex flex-column'>
                                    <div className='d-flex gap-2'>
                                        <span>نام و نام خانوادگی:</span>
                                        <span>مهرداد اکبری</span>
                                    </div>
                                    <div className='d-flex gap-2'>
                                        <span> آدرس:</span>
                                        <span>آمل، کلاکسر، دریا 70</span>
                                    </div>
                                    <div className='d-flex gap-2'>
                                        <span>کد:</span>
                                        <span>87</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xs-12 col-md-6">
                                <div className='d-flex flex-column shadow rounded-2 p-2 bg-light'>
                                    <div className='d-flex justify-content-around border-bottom'>
                                        <span> نوع عوارض:</span>
                                        <span>نوسازی ساختمان</span>
                                    </div>
                                    <div className='d-flex justify-content-around'>
                                        <span>مبلغ:</span>
                                        <span>{Intl.NumberFormat('en-Us').format(870000000)}&nbsp;&nbsp;ریال</span>
                                    </div>
                                    <div className='d-flex justify-content-center'>
                                        <button className="btn btn-warning float-start rgc-follow-btn m-2 text-white"
                                            onClick={() => paymentHandler(4)}
                                        > پرداخت </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default SMSFormPayment
